module.exports = __webpack_public_path__ + "img/vector__two.638d61e7.svg";